var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.781 17.25c0 1.333-.541 2.5-1.625 3.5-1.062 1-2.323 1.5-3.781 1.5-2.292 0-4.052-.76-5.281-2.281C.864 18.448.25 16.344.25 13.656c0-2.5 1.052-5.02 3.156-7.562C5.531 3.552 8.083 1.625 11.062.312l1.376 2.22c-2.355 1.145-4.198 2.478-5.532 4-1.333 1.52-2.104 3.364-2.312 5.53h1.75c1.291 0 2.343.146 3.156.438.813.292 1.469.698 1.969 1.219.479.5.812 1.052 1 1.656.208.604.312 1.23.312 1.875zm15.406 0c0 1.333-.541 2.5-1.625 3.5-1.062 1-2.322 1.5-3.78 1.5-2.292 0-4.053-.76-5.282-2.281-1.23-1.521-1.844-3.625-1.844-6.313 0-2.5 1.052-5.02 3.156-7.562C20.938 3.552 23.49 1.625 26.47.312l1.375 2.22c-2.354 1.145-4.198 2.478-5.532 4-1.333 1.52-2.104 3.364-2.312 5.53h1.75c1.292 0 2.344.146 3.156.438.813.292 1.469.698 1.969 1.219.48.5.813 1.052 1 1.656.208.604.313 1.23.313 1.875z","fill":"#333"}));
}

Quote.defaultProps = {"viewBox":"0 0 29 23"};

module.exports = Quote;

Quote.default = Quote;
